<template>
  <div v-if="paymentType">
    <payment-type-details
      :data-payment-type.sync="paymentType"
      @update:dataPaymentType="updatePaymentType"
    />
    <cash-in-methods class="mt-3" :payment_type_id="paymentType.id" />
  </div>
</template>

<script>
import CashInMethods from "../cashInMethods";
import PaymentTypeDetails from "./details";

export default {
  props: {
    id: {
      required: true,
    },
  },
  components: {
    CashInMethods,
    PaymentTypeDetails,
  },
  data: () => ({
    paymentType: null,
  }),
  mounted() {
    this.fetchPaymentType();
  },
  watch: {
    id() {
      this.fetchPaymentType();
    },
  },
  methods: {
    fetchPaymentType() {
      this.$http
        .get(`/api/v1/transactions/transferPaymentTypes/${this.id}`)
        .then((paymentType) => (this.paymentType = paymentType));
    },
    updatePaymentType(paymentType) {
      if (paymentType) {
        this.paymentType = paymentType;
      }
    },
  },
};
</script>

<style></style>
